import React from "react";
import { observer } from "mobx-react-lite";
import { useMatchDetailsStore } from "../../../stores/StoreContext";
import { TCText } from "../../../components/TCText/TCText";
import { Colors } from "../../../utils/colors";
import { CourtCoverageDescription } from "./CourtCoverageDescription";
import { ClutterGridPlotGraph } from "./clutterGraph/ClutterGridPlotGraph";
import { DownloadUltraAppOverlay } from "../../ultraPromo/components/DownloadUltraAppOverlay";

type props = {};

export const MatchCourtCoverageGraph: React.FC<props> = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div style={styles.container}>
      <TCText
        style={styles.text}
        value={`${matchDetailsStore.clutchMatchCurrentPlayer.name}'s court coverage`}
      />
      <div style={{ position: "relative" }}>
        <CourtCoverageDescription />
        <ClutterGridPlotGraph />
        {matchDetailsStore.isPromoMode ? (
          <DownloadUltraAppOverlay
            style={{ top: 0 }}
            textStyle={{ color: Colors.black }}
          />
        ) : null}
      </div>
    </div>
  );
});

const styles: { [key: string]: React.CSSProperties } = {
  container: { marginTop: 20 },
  text: {
    fontWeight: "600",
    fontSize: 16,
    color: Colors.black,
    marginLeft: 5,
  },
};
